export default __webpack_public_path__ + "static/cloudator-full-3-40515fca64618ebad2f6155aa74b7da4.png";